// import ReactDOM from 'react-dom';
import React, { useState, useEffect, useRef } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { getDateTimeStringSQL } from '../../../../Base/Services/Moment/Luxon';
import { assignAgent } from '../../../../API/Compras/Requisas/PurchareDetailsRequests';
import './AgentesComprasDropDown.scss';

const AgenteComprasDropDown = ({ data, toast, setVisibleMailDialog, setlistadoDetalleRequisiciones, listadoDetalleRequisiciones, agentesCompras }) => {

    const [asignado, setAsignado] = useState(null);

    const refContainer = useRef(null);


    const focus = () => {
        setAsignado(agentesCompras.filter((e) => e.IdAgent === data.AssignedTo)[0]);
      };

    const cambiarAgente = async(e) => {
        let detalle = { ...data.data };
        detalle.AgentName = e.value.AgentName;
        detalle.AssignedTo = e.value.IdAgent;
        detalle.IdStatus = 170;
        detalle.EstadoPR = 'Asignada';
        detalle.AssignDate = getDateTimeStringSQL(new Date());
        let tempo = listadoDetalleRequisiciones;
        const index = tempo.findIndex(detail => detail.IdPurcharesRequestDetail === detalle.IdPurcharesRequestDetail);
        tempo[index] = detalle;
        setlistadoDetalleRequisiciones(tempo);

       const t = await assignAgent(detalle);
         if(t.length > 0){
            console.log('asignado', toast);
            toast.current.show({ severity: 'success', summary: 'Asignado', detail: 'Agente asignado correctamente', life: 3000 });
             setAsignado(e.value);
            // toastShow(toast, 'success', 'Asignado', 'Se asignó el agente de compras correctamente');
            setVisibleMailDialog(true);
        }
        data.stopEditing();
    }


    useEffect(() => {
        focus();
    }, []);


    return (
        <div ref={refContainer} tabIndex={1} className={'AgenteComprasDropDown'}>
            <Dropdown
                value={asignado}
                options={agentesCompras}
                onChange={cambiarAgente}
                optionLabel="AgentName"
                onFocus={focus}
            />
            {/* <input type={'date'} /> */}
        </div>
    )
}

export default AgenteComprasDropDown;